<template>
  <div id="list-gambar-produk">
    <TitleComponent />
    <div class="card mt-3">
      <div class="card-body">
        <div
          class="d-lg-flex d-md-flex align-items-end justify-content-between"
        >
        <div class="d-lg-flex ">
          <div>
            <label for="exampleFormControlInput1">Cari</label>
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="Cari disini"
              v-model="search.search"
              @keyup.enter="readAll"
            />
          </div>
          <div class="ms-1 me-1" v-if="$store.getters['ImageProduct/showListPrincipal']">
              <label for="selectsearch">Principal</label>
              <select
                class="form-select"
                aria-label="Default select example"
                id="selectsearch"
                placeholder="Level"
                v-model="search.compcode"
                @change="readAll"
              >
                <option value="0">-- Pilih --</option>
                <option v-for="(n, i) in listCompany" :key="i" :value="n.compcode" >{{ n.compcode }} - {{ n.compname }}</option>
              </select>
            </div>
          <div class="ms-1 me-1 align-content-end">
              <button class="btn btn-secondary btn-sm"  @click="reloadPage">
                <i class="fas fa-sync-alt"></i>
              </button>
            </div>
        </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-end">
              <i
                class="fas fa-th m-1 icon-mode"
                :class="[modeImageView ? 'active' : '']"
                @click="setModeImage(true)"
              ></i>
              <i
                class="fas fa-list m-1 icon-mode"
                :class="[!modeImageView ? 'active' : '']"
                @click="setModeImage(false)"
              ></i>
            </div>
            <div class="p-1">
              <button
                v-if="!statusCheckedImage && search.status === '1'"
                type="button"
                class="btn btn-outline-primary btn-sm me-1 ms-1"
                @click="$store.commit('ImageProduct/SET_STATUS_CHECKED_IMAGE')"
              >
                Pilih Gambar
              </button>
              <button
                v-if="statusCheckedImage && search.status === '1'"
                type="button"
                class="btn btn-outline-primary btn-sm me-1 ms-1"
                @click="$store.commit('ImageProduct/SET_STATUS_CHECKED_IMAGE')"
              >
                Batal
              </button>
              <button
                v-if="statusCheckedImage && search.status === '1'"
                type="button"
                class="btn btn-outline-danger btn-sm me-1 ms-1"
                data-bs-toggle="modal"
                data-bs-target="#deleteAllModal"
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
        <TableImageComponent v-if="!modeImageView" />
        <GaleryImageComponent v-if="modeImageView" />
        <div
          class="table-footer mt-2 d-lg-flex d-md-flex justify-content-between align-items-center"
        >
          <div
            class="d-flex col justify-content-lg-start justify-content-md-start justify-content-center mb-2 mb-lg-0 mb-sm-0 mb-md-0"
          >
            <DataPageComponent
              :perPage="pagination.perPage"
              :currentPage="pagination.currentPage"
              :totalItems="pagination.totalItems"
            />
          </div>
          <div
            class="col d-flex justify-content-lg-end justify-content-md-end justify-content-center"
          >
            <PaginationComponent
              :pagination="pagination"
              @goto-page="readAll"
            />
          </div>
        </div>
      </div>
    </div>
    <DeleteModalComponent
      idModal="deleteAllModal"
      title="DELETE IMAGES"
      descript="IMAGES ?"
      :images="tempCheckedImages"
      @saveDelete="deleteAll"
    />
  </div>
</template>
<script>
import TitleComponent from "@/components/TitleComponent.vue";
import { getModeImage, getPage } from "@/utils/HandleToken";
import { mapState, mapActions } from "vuex";
import GaleryImageComponent from "@/components/images/galeryImageComponent.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import DataPageComponent from "@/components/DataPageComponent.vue";
import DeleteModalComponent from "@/components/DeleteModalComponent.vue";
import TableImageComponent from "@/components/images/tableImageComponent.vue";

export default {
  name: "ListGambarProdukView",
  components: {
    TitleComponent,
    GaleryImageComponent,
    PaginationComponent,
    DataPageComponent,
    DeleteModalComponent,
    TableImageComponent,
  },
  computed: {
    ...mapState({
      statusCheckedImage: (state) => state.ImageProduct.statusCheckedImage,
      tempCheckedImages: (state) => state.ImageProduct.tempCheckedImages,
      pagination: (state) => state.ImageProduct.pagination,
      modeImageView: (state) => state.ImageProduct.modeImageView,
      listCompany: (state) => state.Company.listCompany,
    }),
    search: {
      get() {
        return this.$store.state.ImageProduct.search;
      },
      set(value) {
        this.$store.commit("ImageProduct/SET_SEARCH", value);
      },
    },
  },
  methods: {
    ...mapActions({
      readAll: "ImageProduct/readAll",
      deleteAll: "ImageProduct/deleteAll",
      setModeImage: "ImageProduct/setModeImage",
      readList: "Company/readList",
    }),
    reloadPage() {
      window.location.reload();
    },
  },
  created() {
    const currentPage = getPage();
    const modeImage = getModeImage();
    this.readAll(currentPage);
    this.setModeImage(modeImage);
    this.readList();
  },
};
</script>
<style scoped>
/* SHOW PERPAGE & TOTAL DATA */
.table-footer .dataperpage p,
.table-footer .totaldata p {
  font-size: 12px;
  padding: 5px 8px !important;
  border-radius: 3px;
  border: 1px solid var(--border-one);
}

.icon-mode {
  font-size: 20px;
  cursor: pointer;
}

.icon-mode.active {
  color: rgba(20, 79, 216, 0.6);
}

.icon-mode:hover {
  color: rgba(20, 79, 216, 0.6);
}
</style>
